import {DeclarativeMutationConfig, graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {CreateProjectStageMutation, CreateProjectStageMutation$data} from './__generated__/CreateProjectStageMutation.graphql';

type CreateProjectStageInput = {
	companyId: string;
	name: string;
};

const mutation = graphql`
	mutation CreateProjectStageMutation($input: CreateProjectStageInput!) {
		createProjectStage(input: $input) {
			projectStageEdge {
				node {
					__typename
					id
					name
					sortOrder
					profile
				}
			}
		}
	}
`;

function getConfigs(input: CreateProjectStageInput): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.companyId,
			connectionInfo: [{key: 'Company_projectStages', rangeBehavior: 'append'}],
			edgeName: 'projectStageEdge',
		},
	];
}

function commit(
	environment: Environment,
	input: CreateProjectStageInput,
	onSuccess?: (response: CreateProjectStageMutation$data) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<CreateProjectStageMutation>(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				name: input.name,
			},
		},
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError,
	});
}

export default {commit};
